import { render, staticRenderFns } from "./AdminUserRights.vue?vue&type=template&id=f7f8347c"
import script from "./AdminUserRights.vue?vue&type=script&lang=ts"
export * from "./AdminUserRights.vue?vue&type=script&lang=ts"
import style0 from "./AdminUserRights.vue?vue&type=style&index=0&id=f7f8347c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports